<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-lg-12 col-12">
        <div class="row">
          <div class="d-flex row flex-row">
            <!-- <div class="d-flex "> -->
            <div class="col-sm-5">
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Buscar por nombre y asunto"
                v-model="valueSearch"
                @keyup.enter="getNotifications"
              />
            </div>
            <div class="col-sm-3">
              <button
                type="button"
                class="btn bg-gradient-dark null null"
                @click="getNotifications()"
                style="margin-left: 10px"
              >Buscar</button>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <!-- <h1>Recibidos</h1> -->
        <Table :columns="columns" :notifications="notifications" :pagination="pagination"></Table>
      </div>
    </div>
  </div>
</template>

<script>
import Table from "./components/Table.vue";
import axios from "axios";

export default {
  name: "ListNotifications",
  components: {
    Table,
  },
  data() {
    return {
      notifications: [],
      isDisabled: false,
      pagination: null,
      columns: [
        {
          name: "Enviado por",
          field: "user_fullname",
        },
        {
          name: "Titulo",
          field: "title",
        },
        {
          name: "Texto", 
          field: "body",
        },
        {
          name: "Asunto",
          field: "message_subject",
        },
        {
          name: "Fecha",
          field: "created_at",
        },
      ],
      valueSearch: null,
    };
  },
  watch: {
    listType(newValue, oldValue) {
      this.getNotifications(newValue);
    },
    valueSearch(newVal) {
      if (newVal == "") {
        this.valueSearch = null;
        this.getNotifications();
      }
    },
  },
  methods: {
    async getNotifications(page = 1) {
      this.$store.commit('setLoading',true);
      try {
        this.isDisabled = true;
        let url = this.valueSearch==null || this.valueSearch=="" ? 
        `${process.env.VUE_APP_API_BOOKAPP}notifications?page=${page}`:
        `${process.env.VUE_APP_API_BOOKAPP}notifications?search=${this.valueSearch}&page=${page}`;
        const { status, data: dataA } = await axios.get(url,
          {
            headers: {
              Authorization: localStorage.getItem("token_bookapp"),
              conexion: localStorage.getItem("conexion"),
            },
          }
        );

        if (status == 200) {
          this.notifications = dataA.data;
          const { data, meta, ...resto } = dataA;
          this.pagination = meta;
          console.log(this.pagination)
        } else {
          console.log("Hubo un error coonsultando las notificaciones");
        }
        this.isDisabled = false;
      } catch (error) {
        console.log("Hubo un error coonsultando las notificaciones");
      }finally{
        this.$store.commit('setLoading',false); 
      }
    },
    async changePage(page) {
      this.getNotifications(page);
    },
  },
  mounted() {
    this.getNotifications(1);
  },
};
</script>
